import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              subaffiliate_condition: {
                history_changes: {
                  edit: {
                    header: 'HEADER',
                    save: 'SUBMIT',
                    back: 'BACK',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
